import { Component, HostBinding, Input, OnDestroy, AfterViewInit, ViewChild, NgZone } from '@angular/core';


@Component({
  selector: 'app-ascension',
  templateUrl: './ascension.component.html',
  styleUrls: ['./ascension.component.scss']
})
export class AscensionComponent implements AfterViewInit, OnDestroy {
  private Game;

  @Input()
  set game(game: any) {
    this.Game = game;
  }

  @ViewChild('bg1', {static: false})
  public bgOne: any;

  @ViewChild('bg2', {static: false})
  public bgTwo: any;

  @ViewChild('bg3', {static: false})
  public bgThree: any;


  private bgOneSize = {
    width: 0,
    height: 0,
  };

  private bgTwoSize = {
    width: 0,
    height: 0,
  };


  private bgThreeSize = {
    width: 0,
    height: 0,
  };

  @HostBinding('class.ascend') ascend = false;

  @HostBinding('class.fadeOut') fadeOut = false;

  public continueLoop = true;
  public ascensionService;
  public previousTimestamp = 0;
  public offsetX = 325;
  public offsetXSpeed = 1.5;
  public isDecending = false;

  constructor(private ngZone: NgZone) {}

  async ngAfterViewInit() {
    await this.getBackgroundImageSizeFromElement(this.bgOne, this.bgOneSize);
    await this.getBackgroundImageSizeFromElement(this.bgTwo, this.bgTwoSize);
    await this.getBackgroundImageSizeFromElement(this.bgThree, this.bgThreeSize);

    this.ascend = true;
    setTimeout(() => {
      window.requestAnimationFrame(this.tick);
    }, 1);
  }


  public tick = (timestamp) => {


    if (!this.previousTimestamp) { this.previousTimestamp = timestamp; }
    const timePassed = timestamp - this.previousTimestamp;
    this.previousTimestamp = timestamp;
    if (isFinite((timePassed / 100))) {
      this.offsetX += this.offsetXSpeed * (timePassed / 100);
      this.bgOne.nativeElement.style.backgroundPositionY = ((this.offsetX * .2) % this.bgOneSize.height) + 'px';
      this.bgTwo.nativeElement.style.backgroundPositionY = (this.offsetX % this.bgTwoSize.height) + 'px';
      this.bgThree.nativeElement.style.backgroundPositionY = ((this.offsetX * 3) % this.bgThreeSize.height) + 'px';

      if (this.isDecending) {
        this.offsetXSpeed += ((this.offsetXSpeed / 5.5) * (timePassed / 100));
      }
    }
    if (this.continueLoop) {
      window.requestAnimationFrame(this.tick);
    }
  }

  public getAvailableAscensionTech() {
    return this.Game.ascensionService.UI_ASCENSION.sort((a, b) => {
      return a[1].costs - b[1].costs;
    });
  }

  public canBuyAscensionTech(tech) {
    return !this.Game.ascensionService.state.unlocked[tech] && this.Game.ascensionService.meetsTechRequirements(tech);
  }

  public researchAscensionTech(tech) {
    return this.Game.ascensionService.research(tech);
  }

  public decend() {
    // this.offsetXSpeed = 20;
    this.Game.setAscensionResources();
    this.isDecending = true;
    this.fadeOut = true;
    this.Game.start();
    setTimeout(() => {
      this.Game.ascensionService.state.isAscending = false;
      this.ngZone.run(() => {});
    }, 4000);
  }

  public getBackgroundImageSizeFromElement(element, sizeObject) {
    return new Promise((resolve) => {
      const url = window.getComputedStyle(element.nativeElement).backgroundImage
        .replace(/"/g, '')
        .replace(/url\(|\)$/ig,  '');
      const image = new Image();
      image.onload = () => {
        sizeObject.height = image.height;
        sizeObject.width = image.width;
        resolve();
      };
      image.src = url;
    });
  }

  public ngOnDestroy(): void {
    this.continueLoop = false;
  }

}
